import 'css-chunksrc/client/common/tagList/styles.scss';export default {
  "tagList": "_tagList_1hzgp_1",
  "list": "_list_1hzgp_9",
  "buttonWrapper": "_buttonWrapper_1hzgp_18"
};